"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_1 = require("./utils");
const ExternalScripts = ({ versions }) => {
    let currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (currentEnv === 'dev') {
        currentEnv = 'qa';
    }
    const scriptsToLoad = (0, utils_1.getScriptsSrc)({ currentEnv, versions }).filter(item => !!item);
    return scriptsToLoad.map((script) => react_1.default.createElement("script", { src: script }));
};
ExternalScripts.propTypes = {
    versions: prop_types_1.default.object,
};
ExternalScripts.defaultProps = {
    versions: {
        IC: '',
        context: '',
        nookinfoexchange: '',
        metrics: '',
    },
};
exports.default = ExternalScripts;
//# sourceMappingURL=index.js.map